module.exports = __webpack_public_path__ + "000642457f54b3420aab3a454f3e9a15.png";